import type { ElementDto } from "@repo/api/overlays";

export type ElementOrdering =
  "bring-to-front" | "bring-forward" | "send-backward" | "send-to-back";

// The first element of a scene is drawn in front.
export function getReorderedElements(
  elements: ElementDto[],
  selectedIds: string[],
  ordering: ElementOrdering,
): ElementDto[] {
  const isBackward =
    ordering === "send-to-back" || ordering === "send-backward";
  const ordered = isBackward ? [...elements].reverse() : elements;
  const isSelected = (element: ElementDto) =>
    selectedIds.includes(element.externalId);

  let sliceIndex = 0;

  if (ordering === "bring-forward" || ordering === "send-backward") {
    sliceIndex = Math.max(0, ordered.findIndex(isSelected) - 1);
  }

  const reordered = [
    ...ordered.slice(0, sliceIndex),
    ...ordered.filter(isSelected),
    ...ordered.slice(sliceIndex).filter((element) => !isSelected(element)),
  ];

  return isBackward ? reordered.reverse() : reordered;
}
